import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-md px-1.5 py-0.5 text-micro font-normal',
  {
    variants: {
      variant: {
        // Contact types — the two first-class record kinds (CONTEXT.md)
        person: 'bg-secondary text-secondary-foreground',
        organization: 'bg-muted text-fog',
        neutral: 'bg-muted text-muted-foreground',
        info: 'bg-info/15 text-info',
        // Functional status: the opaque tint tokens (DESIGN.md status recipe), never a translucent
        // wash — over a hovered row or a muted band success/15 fell to 4.43:1 (#3415).
        success: 'bg-success-tint text-success',
        warning: 'bg-warning-tint text-warning',
        destructive: 'bg-destructive/10 text-destructive',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}
